import { DataGrid, GridFeatureMode } from '@mui/x-data-grid';
import { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { CustomTableFooter } from '../table-footer/table-footer.component';

interface Props extends Omit<ComponentProps<typeof DataGrid>, 'pagination'> {
    page?: number;
    setPage?: (page: number) => void;
    pageSize?: number;
    setPageSize?: (pageSize: number) => void;
    pagination?: boolean;
}
export function Table({
    page,
    setPage,
    pageSize = 5,
    setPageSize,
    pagination,
    paginationMode = 'server',
    sortingMode = 'server',
    ...props
}: Props) {
    const { t } = useTranslation();
    const paginationOptions: Partial<ComponentProps<typeof DataGrid>> =
        pagination === false
            ? {
                  hideFooter: true,
              }
            : paginationMode === 'server'
            ? {
                  pagination: true as const,
                  paginationMode: 'server' as GridFeatureMode,
                  pageSizeOptions: props.pageSizeOptions ? props.pageSizeOptions : [5, 10, 20],
                  paginationModel: { page: page ? page - 1 : 0, pageSize: pageSize },
                  onPaginationModelChange: (value) => {
                      setPage?.(value?.page + 1);
                      setPageSize?.(value?.pageSize || 5);
                  },
              }
            : { pagination: true as const, paginationMode: 'client' as GridFeatureMode };

    return (
        <>
            {!props.loading && (
                <DataGrid
                    sortingMode={sortingMode}
                    sortingOrder={['asc', 'desc']}
                    disableColumnFilter
                    disableColumnMenu
                    slots={{ footer: CustomTableFooter }}
                    localeText={{ noRowsLabel: t('noRows') }}
                    {...paginationOptions}
                    {...props}
                />
            )}
        </>
    );
}
